module.exports = __webpack_public_path__ + "static/step-two-df2bcafe68f2c69ca7ed0ed394b237de.png";